import { useState } from 'react'
import { useTranslation } from 'react-i18next';

export default function FAQs() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(0);
  const faqs = [
    { question: t('qaQuestion1'), answer: t('qaAnswer1') },
    { question: t('qaQuestion2'), answer: t('qaAnswer2') },
    { question: t('qaQuestion3'), answer: t('qaAnswer3') },
  ];

  return (
    <section id="faq" className="bg-surface px-6 py-24 sm:py-28 lg:px-16">
      <div className="mx-auto flex max-w-[760px] flex-col gap-10">
        <div className="flex flex-col items-center gap-3.5 text-center">
          <h2 className="text-4xl font-bold tracking-[-1px] text-ink">{t("qaTitle")}</h2>
        </div>
        <div className="flex flex-col gap-3">
          {faqs.map((faq, i) => {
            const isOpen = open === i
            return (
              <div key={i} className="overflow-hidden rounded-[18px] bg-cream">
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-6 py-[22px] text-left text-base font-bold text-ink"
                >
                  {faq.question}
                  <span
                    className={
                      'flex h-[30px] w-[30px] flex-shrink-0 items-center justify-center rounded-full text-lg font-semibold transition-all ' +
                      (isOpen ? 'bg-ink text-white' : 'border border-border_soft bg-surface text-muted')
                    }
                  >
                    {isOpen ? '−' : '+'}
                  </span>
                </button>
                {isOpen && (
                  <p className="px-6 pb-6 text-[15px] leading-relaxed text-muted">{faq.answer}</p>
                )}
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
